import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Navbar from './Navbar'
import Sidebar from '../../containers/Layout/Sidebar'

const Main = ({
  backTo,
  children,
  event,
  iconType,
  isSidebar,
  subtitle,
  title,
}) => {
  const [ sidebarActive, setSideBarActive ] = useState(false)

  const toggleSidebarActive = () => {
    sidebarActive
      ? document.body.classList.remove('sidebar-open')
      : document.body.classList.add('sidebar-open')

    setSideBarActive(!sidebarActive)
  }

    return (
      <>
        <Navbar
          backTo={backTo}
          event={event}
          iconType={iconType}
          isSidebar={isSidebar}
          subtitle={subtitle}
          title={title}
          toggleSidebarActive={toggleSidebarActive}
        />
        {isSidebar && (
          <Sidebar
            isOpen={sidebarActive}
            toggleSidebarActive={toggleSidebarActive}
          />
        )}
        <main className="layout">{children}</main>
        <div className="version-box">
          <div className="version-box__version-number">{process.env.REACT_APP_VERSION}</div>
        </div>
      </>
    )
}

Main.defaultProps = {
  backTo: '',
  event: {},
  title: '',
}

Main.propTypes = {
  backTo: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
  event: PropTypes.object,
  isSidebar: PropTypes.bool,
  title: PropTypes.string,
}

export default Main
